export default __webpack_public_path__ + "static/media/IMG_02_th.f5c10261.jpg";